//var responsiveHomepage = (function () {
//    'use strict';

//    var functionality = {
//        mobileHeader : $('.mobile-header'),
//        toggleMenu: toggleMenu
//    };

//    return functionality;

//    function toggleMenu(side) {
//        var opposite = '';
//        opposite = (side === 'left') ? 'right' : 'left';

//        if (!functionality.mobileHeader.hasClass('mobile-header--active-' + side)) {
//            functionality.mobileHeader.addClass('mobile-header--active-' + side).removeClass('mobile-header--active-' + opposite);
//        } else {
//            functionality.mobileHeader.removeClass('mobile-header--active-' + side);
//        }
//    }
//})();

//homepage

function toggleMenu(side) {
    var mobileHeader = $('.mobile-header');
    var opposite = '';
    opposite = (side === 'left') ? 'right' : 'left';

    if (!mobileHeader.hasClass('mobile-header--active-' + side)) {
        mobileHeader.addClass('mobile-header--active-' + side).removeClass('mobile-header--active-' + opposite);
    } else {
        mobileHeader.removeClass('mobile-header--active-' + side);
    }
}

function hideAllMenus() {
    // prevent errors
}

//flightsearch

var jqDP_DATE_FORMAT_STRING = 'dd/mm/yy';

if ($('#fsdepart')) {
    var datepickerOptionsDepart = {
        onSelect: function (date) {
            var dateString = date.split('/');
            var dateObj = new Date(dateString[2] + '/' + dateString[1] + '/' + (+dateString[0]));
            console.log('in seven days', dateObj);
            $("#fsreturn").datepicker("setDate", new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate() + 7));
        },
        minDate: 1, //TODAY
        maxDate: 365, //1 YEAR IN THE FUTURE
        dateFormat: jqDP_DATE_FORMAT_STRING,
        prevText: 'Earlier',
        nextText: 'Later',
        duration: 10,
        gotoCurrent: true,
        numberOfMonths: 2,
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
    };

    var datepickerOptionsReturn = {
        minDate: 1, //TODAY
        maxDate: 365, //1 YEAR IN THE FUTURE
        dateFormat: jqDP_DATE_FORMAT_STRING,
        prevText: 'Earlier',
        nextText: 'Later',
        duration: 10,
        gotoCurrent: true,
        numberOfMonths: 2,
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
    };

    $(document).ready(function () {
        if ($('#fsdepart').length) {
            $('#fsdepart').datepicker(datepickerOptionsDepart);
            $('#fsreturn').datepicker(datepickerOptionsReturn);
        }
    });

}